// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("@assets/images/background/bg_default_1.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* @tailwind utilities;
@layer utilities {
  .bubble-dropdown {
    @apply absolute left-4 top-20;
  }
} */

.account-menu-body {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.bubble-details {
  transition: height 0.3s, opacity 0.3s;
}

.account-menu-bubble-container.open .bubble-details {
  height: 100%;
}

.account-menu-bubble-container.open > svg {
  transform: rotate(180deg);
}

.link-to-bubble-store svg {
  fill: currentColor;
  height: 1rem /* 16px */;
  margin-right: 0.25rem /* 4px */;
}

.account-menu-bubble-container > svg {
  fill: currentColor;
  transition: all 0.2s ease-out;
  height: 1.25rem /* 20px */;
  margin-left: auto;

  /* text-primary-apricot */
  --tw-text-opacity: 1;
  color: rgb(247 148 30 / var(--tw-text-opacity));
}
.bubble-details {
  opacity: 0;
}

.bubble-details.open {
  opacity: 1;
  overflow: visible;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/account/AccountOverlay.css"],"names":[],"mappings":"AAAA;;;;;GAKG;;AAEH;EACE,yDAAmE;AACrE;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,0BAA0B;EAC1B,iBAAiB;;EAEjB,yBAAyB;EACzB,oBAAoB;EACpB,+CAA+C;AACjD;AACA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;EACV,iBAAiB;AACnB","sourcesContent":["/* @tailwind utilities;\n@layer utilities {\n  .bubble-dropdown {\n    @apply absolute left-4 top-20;\n  }\n} */\n\n.account-menu-body {\n  background-image: url('@assets/images/background/bg_default_1.svg');\n}\n\n.bubble-details {\n  transition: height 0.3s, opacity 0.3s;\n}\n\n.account-menu-bubble-container.open .bubble-details {\n  height: 100%;\n}\n\n.account-menu-bubble-container.open > svg {\n  transform: rotate(180deg);\n}\n\n.link-to-bubble-store svg {\n  fill: currentColor;\n  height: 1rem /* 16px */;\n  margin-right: 0.25rem /* 4px */;\n}\n\n.account-menu-bubble-container > svg {\n  fill: currentColor;\n  transition: all 0.2s ease-out;\n  height: 1.25rem /* 20px */;\n  margin-left: auto;\n\n  /* text-primary-apricot */\n  --tw-text-opacity: 1;\n  color: rgb(247 148 30 / var(--tw-text-opacity));\n}\n.bubble-details {\n  opacity: 0;\n}\n\n.bubble-details.open {\n  opacity: 1;\n  overflow: visible;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
